/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';

  /**
   * Хелпер для подключения подсказок по адресам.
   */
  app.helpers.DaDataHelper = {

    /**
     * Получение конфигурации плагина подсказок для соответствующих полей
     * @param options Опции для подключения плагина подсказок
     * @returns {{serviceUrl: string, token: string, type: string, hint: boolean, onSearchComplete: baseConfig.onSearchComplete}}
     */
    getSuggestionsConfig: function (options) {
      var serviceUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',
        token = '456b824510e1ccf20fb23f1e5695179a9a38dab1 ',
        type = options.type ? options.type : 'ADDRESS',
        baseConfig = {
          serviceUrl: serviceUrl,
          token: token,
          type: type,
          hint: false,
          bounds: options.fieldType,
          onInvalidateSelection: options.onInvalidateSelection,
          onSelect: options.onSelect,
          noSuggestionsHint: false
        };
      if (options.fieldType === 'street') {
        baseConfig.constraints = {
          locations: {
            kladr_id: options.kladrId
          },
          deletable: false
        };
        baseConfig.onSearchComplete = options.onSearchComplete;
        // в списке подсказок не показываем область и город
        baseConfig.restrict_value = true;
        baseConfig.onSelectNothing = options.onSelectNothing;
        return baseConfig;
      }
      baseConfig.constraints = options.street;
      return baseConfig;
    },
    /**
     * Инициализирует подсказки в переданной вью.
     * @param {app.View} view Вью формы где необходимо инициализировать подсказки
     * @param {object} options Опции для инициализации
     */
    initDaDataSuggestions: function (view, options) {
      if (!view || !(view instanceof app.View)) {
        throw new RangeError('View argument is not instance of app.View');
      }
      var street = view.$(options.streetFieldSelector),
        house = view.$(options.houseFieldSelector),
        helper = app.helpers.DaDataHelper,
        setSuggestions = function () {
          var counter = 0,
            newOptions = options,
            streetOptions;
          newOptions.fieldType = 'street';
          newOptions.kladrId = view.settlement.get('kladr_id');
          if (view instanceof app.FormView) {
            newOptions.onInvalidateSelection = view.setDataToModel.bind(view);
          }
          if (_.isFunction(view.selectSuggestion)) {
            newOptions.onSelect = view.selectSuggestion.bind(view);
          }
          streetOptions = _.clone(newOptions);
          streetOptions.onSearchComplete = function (query, suggestions) {
            counter = suggestions && suggestions.length ? suggestions.length : 0;
          };
          streetOptions.onSelectNothing = function () {
            if (counter >= 1) {
              view.$(this).val('');
              if (view instanceof app.FormView) {
                view.setDataToModel();
              }
            }
            if (view instanceof app.FormView && _.isFunction(view.onSelectNothing)) {
              view.onSelectNothing();
            }
          };
          street.suggestions(helper.getSuggestionsConfig(streetOptions));
          newOptions.fieldType = 'house';
          newOptions.street = street;
          house.suggestions(helper.getSuggestionsConfig(newOptions));
        };
      if (view.settlement.get('kladr_id')) {
        setSuggestions();
      }
      view.listenTo(view.settlement, 'change:kladr_id', function () {
        if (view.settlement.get('kladr_id')) {
          setSuggestions();
          return;
        }
        street.suggestions().dispose();
        house.suggestions().dispose();
      });
    }
  };
})();

}.call(window));